const xdownloaderConfig = {
  tableTitle: '',
  tableSelector: '.ns-table-wrap',
  excludeTableSelector: '',
  downloadText: "Download xlsx", //Can be empty if you want to use an icon instead
  mergeStrings: [],
  numFmt: (cell, cellIndex, rowIndex) => {
    if ((String(cell.value).replace(' ', '')).trim().match(/^[+-]?(\d*\.\d+|\d+\.\d*|\d+)$/) && !['2018', '2019', '2020', '2021', '2022', '2023', '2024'].includes((String(cell.value).replace(' ', '')).trim())) {
      cell.value = parseFloat(String(cell.value).trim().replace(' ', ''));
      if (String(cell.value).indexOf('.') > -1) {
        cell.numFmt = '#,##0.??';
      }
      else {
        cell.numFmt = '#,##0';
      }
      // console.log(cell._address, cell.value)
    }
  },
  tableCellFormatter: (h) => {
    let cell = document.createElement('td');
    cell.innerHTML = h.innerHTML;
    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText + ')';
      superscript.parentNode.removeChild(superscript);
    }

    let cellContent = '';
    let cellSpans = cell.querySelectorAll('span');
    if (cellSpans.length > 0) {
      cellSpans.forEach(span => {
        if(!/<span\b[^>]*>(.*?)<\/span>/i.test(span.innerHTML)) {
          cellContent += span.innerText
        }
      })
    } else {
      let paragraph = cell.querySelector('p');
      cellContent += paragraph?.innerText;
    }

    return cellContent.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/,/g, '.').replace(/–/g, '-').replace(/,/g, '.');
  },
  styles: [
    {
      class: 'ns-horizontal-left',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FFB3AEA6'
          }
        },
      },
    },
    {
      class: 'ns-horizontal-right',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FFB3AEA6'
          }
        },
      },
    },
    {
      class: 'ns-horizontal-center',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FFB3AEA6'
          }
        },
      },
    },
    {
      class: 'head',
      font: {
        bold: true
      },
      border: {
        bottom: {
          style: 'thick',
          color: {
            argb: 'FF608c3e'
          },
          index: 10
        },
      },
    },
    {
      class: 'gline_bold',
      font: {
        bold: true
      },
      border: {
        bottom: {
          style: 'thick',
          color: {
            argb: 'FF608c3e'
          },
          index: 10
        },
      },
    },
    {
      class: 'line_bold',
      font: {
        bold: true
      }
    },
    {
      class: 'bold',
      font: {
        bold: true
      }
    },
    {
      class: 'green',
      font: {
        color: {
          argb: 'FF608C3E'
        }
      }
    },
    {
      class: ['green', 'line_bold'],
      font: {
        bold: true,
        color: {
          argb: 'FF608C3E'
        }
      }
    },
    {
      class: ['green', 'bold'],
      font: {
        bold: true,
        color: {
          argb: 'FF608C3E'
        }
      }
    },
    {
      class: ['gline_bold', 'green'],
      font: {
        bold: true,
        color: {
          argb: 'FF608C3E'
        }
      }
    },
    {
      class: 'noline',
      border: {
        bottom: {
          style: 'none'
        }
      }
    },
    {
      class: 'nl',
      border: {
        bottom: {
          style: 'none'
        }
      }
    },
    {
      class: 'ns-backgroundcolor-gf_3a-green',
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF6ab04c'
        }
      }
    },
    {
      class: 'ns-background-10',
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF38452e'
        }
      }
    },
    {
      class: 'ns-background-09',
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF9ba296'
        }
      }
    },
    {
      class: 'ns-background-08',
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF6a7462'
        }
      }
    }
  ]
};

export default xdownloaderConfig;
